import Api from "@/api/stories.js";
import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";

export default function stories() {
    let models = ref([]);

    let route = useRoute()
    let router = useRouter()

    let baseUrl = process.env.VUE_APP_API;

    let id = ref(null);
    let title = ref("");
    let text = ref("");
    let author = ref("");
    let status = ref("");
    let price = ref("");
    let shortDescription = ref("");
    let description = ref("");
    let ImageTitle = ref("");
    let openPickImage = ref(false)
    let statusOptions = ref([
        { value: 1, text: "Активный" },
        { value: 0, text: "Не активный" },
    ]);
    let chapters = ref([]);

    const createStory = async () => {
        await Api.createModel({
            title: title.value,
            short_description: shortDescription.value,
            description: description.value,
            text: text.value,
            author: author.value,
            status: status.value,
            price: price.value,
            title_image: ImageTitle.value,
        });

        router.push("/stories/");
    };

    const updateStory = async () => {
        await Api.updateModel(route.params.id, {
            title: title.value,
            short_description: shortDescription.value,
            description: description.value,
            text: text.value,
            author: author.value,
            status: status.value,
            price: price.value,
            title_image: ImageTitle.value,
        });

        alert("Рассказ успешно обновлен");
    }


    const deleteStory = async () => {
        let isDelete = confirm("Вы действительно хотите удалить рассказ?");

        if (isDelete === true) {
            await Api.deleteModel(route.params.id);
            router.push("/stories/");
        }
    }


    const getStory = async (withText = false) => {

        let fieldsArray = [
            'id',
            'title',
            'text',
            'short_description',
            'description',
            'author',
            'status',
            'price',
            'ImageTitle',
            'storiesChapters.id',
            'storiesChapters.title',
            'storiesChapters.order'
        ];

        if (withText){
            fieldsArray.push('storiesChapters.text')
        }

        const fields = fieldsArray.join(',')

        let response = await Api.getModel(route.params.id, { expand: "storiesChapters", fields: fields });

        id.value = response.data.id;
        title.value = response.data.title;
        text.value = response.data.text;
        shortDescription.value = response.data.short_description;
        description.value = response.data.description;
        author.value = response.data.author;
        status.value = response.data.status;
        ImageTitle.value = response.data.title_image;
        price.value = response.data.price;
        chapters.value = response.data.storiesChapters;
    }

    const getStories = async () => {
        let response = await Api.getModels({ fields: ['id', 'title'].join(',') });
        models.value = response.data;
    }

    return {
        models, getStories, shortDescription, openPickImage, ImageTitle, getStory, deleteStory, updateStory, createStory, baseUrl, id, title, description, text, author, status, statusOptions, chapters, price
    };
}
